(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterAntragController', ReiterAntragController);

    ReiterAntragController.$inject = [
        '$scope',
        '$log',
        '$filter',
        'lodash',
        'moment',
        'schluesselwerte',
        'AppConfig',
        'AngebotKfzService',
        'BasisAngebotService',
        'AngebotUtilsService',
        'MiscUtilsService',
        'FormFieldUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function ReiterAntragController($scope, $log, $filter, _, moment, schluesselwerte, AppConfig, AngebotKfzService, BasisAngebotService, AngebotUtilsService, MiscUtilsService, FormFieldUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            altvertragObjekt = BasisAngebotService.getAltvertragObjekt(angebotVm.angebotModel.angebot),
            wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
            wagniskennziffern = AppConfig.ANGEBOT.kfz.wkz,
            erlaubteTarifmerkmale = AngebotKfzService.getErlaubteTarifmerkmale(angebotVm.angebotModel.angebot);

        $log.debug('ReiterAntragController', vm);

        vm.placeholders = {};

        vm.resetValue = resetValue;
        vm.isKilometerstandErlaubt = isKilometerstandErlaubt;
        vm.onKilometerstandChanged = onKilometerstandChanged;
        vm.isFinanzierungErlaubt = isFinanzierungErlaubt;
        vm.isAmtlichesKennzeichenErlaubt = isAmtlichesKennzeichenErlaubt;
        vm.isFahrgestellnummerErlaubt = isFahrgestellnummerErlaubt;
        vm.isAndereHerstellerErlaubt = isAndereHerstellerErlaubt;
        vm.checkFahrgestellnummer = checkFahrgestellnummer;
        vm.isVorversichererErlaubt = isVorversichererErlaubt;
        vm.isBlockBisherigesFahrzeugErlaubt = isBlockBisherigesFahrzeugErlaubt;
        vm.isBisherigesFahrzeugDatumErlaubt = isBisherigesFahrzeugDatumErlaubt;
        vm.setLabelBisherigesFahrzeugDatum = setLabelBisherigesFahrzeugDatum;
        vm.isBlockRabattuebertragungErlaubt = isBlockRabattuebertragungErlaubt;
        vm.isRabattuebertragungVorversicherungAufDrittenErlaubt = isRabattuebertragungVorversicherungAufDrittenErlaubt;
        vm.handleRabattuebertragungBeziehung = handleRabattuebertragungBeziehung;
        vm.isRabattuebertragungAnspruchsberechtigterVerstorbenDisabled = isRabattuebertragungAnspruchsberechtigterVerstorbenDisabled;
        vm.isBlockKurzzeitkennzeichenErlaubt = isBlockKurzzeitkennzeichenErlaubt;
        vm.isAmtlichesKennzeichenDisabled = isAmtlichesKennzeichenDisabled;
        vm.isBlockVorversicherungInternExternErlaubt = isBlockVorversicherungInternExternErlaubt;
        vm.isYDVertragsnummerErlaubt = isYDVertragsnummerErlaubt;
        vm.isMopedVertragsnummerErlaubt = isMopedVertragsnummerErlaubt;
        vm.onGevoVorversicherungInternExternChanged = onGevoVorversicherungInternExternChanged;
        vm.isGevo = isGevo;
        vm.onBisherigesFahrzeugAuswahlChanged = onBisherigesFahrzeugAuswahlChanged;

        activate();

        function activate() {
            vm.isKurzzeitKennzeichenAusgegebenPflicht = isBlockKurzzeitkennzeichenErlaubt();
            vm.vorversicherungProduktnummer = _.get(angebotVm.angebotModel.angebot, 'bausteinHaftpflicht.produkt.wert');
            vm.blockVorversicherungOptions = {};
            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(angebotVm.angebotModel.angebot);

            vm.titleRabattuebernahme = vm.isPrivatPerson ? 'Weitere Angaben zur Rabattübernahme' : 'Weitere Angaben zum Mitversicherungsnehmer';
            vm.mitversicherungsnehmerRollen = SchluesselWerteUtilsService.getSchluesselwert('rolleMitversicherungsnehmerKfz');

            MiscUtilsService.setDefaultValueIfEmpty(angebotVm.angebotModel.angebot, 'mitversicherungsnehmer.partnerMitversicherungsnehmer', {});
            vm.blockVorversicherungOptions = getBlockVorversicherungOptions();
            if (
                isBlockRabattuebertragungErlaubt() &&
                !isRabattuebertragungVorversicherungAufDrittenErlaubt() &&
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER, // 541
                    wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN, // 451
                    wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN // 452
                ], wkz)
            ) {
                _.set(angebotVm.angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten', true);
            }
            if (isGevo('KFZ_VERSICHERERWECHSEL_NEUES_FZG')) {
                vm.isKurzzeitKennzeichenAusgegebenPflicht = false;
            }

            if (schluesselwerte) {
                _.merge(angebotVm.sw, schluesselwerte);
            }

            if (BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANTRAG')) {
                handleRabattuebertragungBeziehung();
            }

            vm.placeholders = {
                angebotsgegenstandFahrzeugKilometerstand: {
                    isGreaterThan: [
                        $filter('numberString')(_.get(altvertragObjekt, 'kilometerstand'), 0) + ' km'
                    ]
                },
                angebotsgegenstandFahrzeugBisherigesFahrzeugDatum: {
                    'min, max': [
                        $filter('date')(angebotVm.currentDateMinus120yearsYYYYMMDD, 'dd.MM.yyyy'),
                        $filter('date')(angebotVm.currentDatePlus10yearsYYYYMMDD, 'dd.MM.yyyy')
                    ]
                },
                rabattuebertragungVerstorbenAm: {
                    'min, max': [
                        $filter('date')(angebotVm.currentDateMinus120yearsYYYYMMDD, 'dd.MM.yyyy'),
                        $filter('date')(angebotVm.currentDatePlus10yearsYYYYMMDD, 'dd.MM.yyyy')
                    ]
                },
                rabattuebertragungVerzichtZum: {
                    'min, max': [
                        $filter('date')(angebotVm.currentDateMinus120yearsYYYYMMDD, 'dd.MM.yyyy'),
                        $filter('date')(angebotVm.currentDatePlus10yearsYYYYMMDD, 'dd.MM.yyyy')
                    ]
                },
                rabattuebertragungAusgabeDatumFahrerlaubnis: {
                    'min, max': [
                        $filter('date')(angebotVm.currentDateMinus120yearsYYYYMMDD, 'dd.MM.yyyy'),
                        $filter('date')(angebotVm.currentDatePlus10yearsYYYYMMDD, 'dd.MM.yyyy')
                    ]
                }
            };

            MiscUtilsService.setDefaultValueIfEmpty(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter', {});

            vm.setLabelBisherigesFahrzeugDatum();
        }

        function getBlockVorversicherungOptions() {
            var vorversicherungOptions = {
                radioTagFormControl: true,
                showInfo: true,
                showVorversicherungVorhanden: false,
                showBeiWemBestandVorversicherung: false,
                beiWemBestandVorversicherung: _.get(angebotVm.CONSTANTS, 'vorversicherungFremdversicherung.wert'),
                showBeiWemBestandVorversicherungGesellschaft: true,
                showAblaufdatumDerVorversicherung: false,
                showWurdeVertragGekuendigt: false,
                showGueltigFuerGegenstand: false,
                showVorversicherungsdauer: false,
                validations: {
                    fremdgesellschaftVersicherungsscheinnummer: {
                        maxlength: 20
                    }
                }
            };

            if (isGevo(['KFZ_ZUSAETZLICHER_VERTRAG', 'KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_FAHRZEUGWECHSEL', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG'])) { // Gevo 2, 3, 4, 4b
                vm.vorversicherungLabelVersicherungsnummer = 'Bisherige Vertragsnummer';
            } else if (isGevo(['KFZ_TRANSFERBESTIMMUNG_28'])) {
                vm.vorversicherungLabelVersicherungsnummer = 'Vertragsnummer des anzurechnenden Rabatts';
            }

            if (isGevo(['KFZ_VERSICHERERWECHSEL_SELBES_FZG', 'KFZ_VERSICHERERWECHSEL_NEUES_FZG'])) { // Gevo  3, 4b
                vorversicherungOptions.showBeiWemBestandVorversicherung = false;
                vorversicherungOptions.beiWemBestandVorversicherung = _.get(angebotVm.CONSTANTS, 'vorversicherungFremdversicherung.wert');
                vorversicherungOptions.showBeiWemBestandVorversicherungGesellschaft = true;
                vorversicherungOptions.showVorversicherungsdauer = !AngebotKfzService.isTarifAb052025(angebotVm.angebotModel.angebot);
                vorversicherungOptions.showInfo = false;

            } else if (isGevo(['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_ZUSAETZLICHER_VERTRAG'])) { // Gevo  1b, 2
                vorversicherungOptions.showBeiWemBestandVorversicherung = false;

                if (_.get(angebotVm.angebotModel.formData, 'gevoVorversicherungInternExtern') === true) {
                    vorversicherungOptions.beiWemBestandVorversicherung = _.get(angebotVm.CONSTANTS, 'vorversicherungUnternehmen.wert');
                    vorversicherungOptions.showBeiWemBestandVorversicherungGesellschaft = false;
                } else {
                    vorversicherungOptions.beiWemBestandVorversicherung = _.get(angebotVm.CONSTANTS, 'vorversicherungFremdversicherung.wert');
                    vorversicherungOptions.showBeiWemBestandVorversicherungGesellschaft = true;
                }

                vorversicherungOptions.showVorversicherungsdauer = false;

                if (isGevo('KFZ_ZUSAETZLICHER_VERTRAG')) { // Gevo  2
                    vorversicherungOptions.showInfo = false;
                }

            } else if (isGevo(['KFZ_FAHRZEUGWECHSEL'])) { // Gevo  4
                vorversicherungOptions.showBeiWemBestandVorversicherung = false;
                vorversicherungOptions.beiWemBestandVorversicherung = _.get(angebotVm.CONSTANTS, 'vorversicherungUnternehmen.wert');
                vorversicherungOptions.showBeiWemBestandVorversicherungGesellschaft = false;
                vorversicherungOptions.showInfo = false;
                vorversicherungOptions.showVorversicherungsdauer = false;
            }

            return vorversicherungOptions;
        }
        function resetValue(modelExpression, value) {
            FormFieldUtilsService.resetValue($scope, modelExpression, value);
        }
        function isKilometerstandErlaubt() {
            return (
                (
                    _.includes([
                        wagniskennziffern.PKW,
                        wagniskennziffern.MOTORRAD
                    ], wkz) &&
                    !_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug', false)
                ) || (
                    _.includes([
                        wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM,
                        wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM,
                        wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE
                    ], wkz)
                ) || (
                    erlaubteTarifmerkmale.jaehrlicheFahleistung &&
                    _.includes([
                        wagniskennziffern.PKW,
                        wagniskennziffern.MOTORRAD
                    ], wkz) &&
                    AngebotKfzService.isTarifAb052025(angebotVm.angebotModel.angebot)
                )
            );
        }

        function onKilometerstandChanged(kilometerstand) {
            if (kilometerstand) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.datumKilometerstand', moment().format(AppConfig.API.dateFormat));
            }
        }
        function isFinanzierungErlaubt() {
            return erlaubteTarifmerkmale.finanzierung !== true;
        }
        function isAmtlichesKennzeichenErlaubt() {
            return isGevo('KFZ_VERSICHERERWECHSEL_SELBES_FZG'); // Gevo 3
        }
        function isFahrgestellnummerErlaubt() {
            return isGevo('KFZ_VERSICHERERWECHSEL_SELBES_FZG'); // Gevo 3
        }
        function isAndereHerstellerErlaubt() {
            return (
                !angebotVm.isErsatzgeschaeft() &&
                !_.includes([
                    wagniskennziffern.PKW,
                    wagniskennziffern.MOTORRAD
                ], wkz)
            );
        }
        function checkFahrgestellnummer(value) {
            if (!BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANTRAG')) {
                return true;
            }

            return AngebotUtilsService.isFahrgestellnummerValid(value);
        }
        function isVorversichererErlaubt() {
            return AngebotKfzService.isVorversichererErlaubt(angebotVm.angebotModel);
        }
        function isBlockBisherigesFahrzeugErlaubt() {
            return AngebotKfzService.isBisherigesFahrzeugErlaubt(angebotVm.angebotModel.angebot);
        }
        function isBisherigesFahrzeugDatumErlaubt() {
            var bisherigesFahrzeugAuswahl = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl');

            return (
                isGevo(['KFZ_FAHRZEUGWECHSEL']) && // 4
                _.includes([
                    'VERKAUFT',
                    'ABGEMELDET'
                ], bisherigesFahrzeugAuswahl)
            );
        }
        function setLabelBisherigesFahrzeugDatum() {
            if (isBisherigesFahrzeugDatumErlaubt()) {
                var bisherigesFahrzeugAuswahl = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl');

                vm.labelAngebotsgegenstandFahrzeugBisherigesFahrzeugDatum = bisherigesFahrzeugAuswahl === 'VERKAUFT' ? 'Verkaufsdatum' : 'Abmeldedatum';
            }
        }
        function isBlockRabattuebertragungErlaubt() {
            return (
                (
                    isGevo([
                        'KFZ_TRANSFERBESTIMMUNG_28', // '1b'
                        'KFZ_VERSICHERERWECHSEL_SELBES_FZG' // '3'
                    ]) || (
                        !vm.isPrivatPerson &&
                        isGevo([
                            'KFZ_FAHRZEUGWECHSEL', // 4
                            'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b'
                        ])
                    )
                ) &&
                erlaubteTarifmerkmale.sfKlassen
            );
        }
        function isRabattuebertragungVorversicherungAufDrittenErlaubt() {
            return (
                (
                    isGevo([
                        'KFZ_VERSICHERERWECHSEL_SELBES_FZG' // '3'
                    ]) ||
                    (
                        isGevo([
                            'KFZ_FAHRZEUGWECHSEL', // 4
                            'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b'
                        ]) &&
                        !vm.isPrivatPerson
                    )
                ) &&
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER // 541
                ], wkz) &&
                (
                    (
                        _.includes([
                            wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN, // 451
                            wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN // 452
                        ], wkz) &&
                        (
                            angebotVm.angebotModel.wurdeGeladen ||
                            angebotVm.angebotModel.wurdeKopiert
                        ) &&
                        _.get(angebotVm.angebotModel.angebotOriginal, 'rabattuebertragung.vorversicherungAufDritten') === true
                    ) || (
                    !_.includes([
                        wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN, // 451
                        wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN // 452
                    ], wkz)
                    )
                )
            );
        }
        function handleRabattuebertragungBeziehung() {
            if (_.get(angebotVm.angebotModel.angebot, 'rabattuebertragung.beziehung.wert') === 'JURISTISCH') {
                _.set(angebotVm.angebotModel.angebot, 'rabattuebertragung.anspruchsberechtigterVerstorben', false);
            }
        }
        function isRabattuebertragungAnspruchsberechtigterVerstorbenDisabled() {
            return _.get(angebotVm.angebotModel.angebot, 'rabattuebertragung.beziehung.wert') === 'JURISTISCH';
        }
        function isBlockKurzzeitkennzeichenErlaubt() {
            return isGevo([
                'KFZ_NEUGESCHAEFT', // 1,
                'KFZ_TRANSFERBESTIMMUNG_28', // '1b'
                'KFZ_ZUSAETZLICHER_VERTRAG', // 2
                'KFZ_FAHRZEUGWECHSEL', // 4
                'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b
            ]);
        }
        function isAmtlichesKennzeichenDisabled() {
            return (
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.amtlKennzeichen') === false
            );
        }

        function isBlockVorversicherungInternExternErlaubt() {
            return AngebotKfzService.isVorversicherungInternExternErlaubt(angebotVm.angebotModel.angebot);
        }
        function isYDVertragsnummerErlaubt() {
            return (
                erlaubteTarifmerkmale.sondereinstufungYD &&
                _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungYD')
            );
        }
        function isMopedVertragsnummerErlaubt() {
            return (
                erlaubteTarifmerkmale.sondereinstufungMoped &&
                _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped')
            );
        }

        function onGevoVorversicherungInternExternChanged(value) {
            vm.blockVorversicherungOptions = getBlockVorversicherungOptions();
        }
        function isGevo(gevo) {
            return AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, gevo);
        }

        function onBisherigesFahrzeugAuswahlChanged(bisherigesFahrzeugAlsZweitesFahrzeug) {
            if (bisherigesFahrzeugAlsZweitesFahrzeug === true) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl', 'ZUSAETZLICHES');
            } else if (bisherigesFahrzeugAlsZweitesFahrzeug === false) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl', 'DEMNAECHST_VER_ABG');
            }

            setLabelBisherigesFahrzeugDatum();
        }
    }
})();
